/**
 * HTTP request layer
 * if auth is required return patched axios instance(with access token in headers)
 * else return clear axios instance
 */

import axios from 'axios'
import {API_URL} from '../env'
import {_getAccessToken, _checkUserExpiration, _resetAuthData} from '../services/utils'
import callRefreshToken from './refreshToken'

import DeferredPromise from "./DeferredPromise";

export default class Http {
	constructor() {
		this.instance = axios.create({
			baseURL: API_URL,
			headers: {
				'Accept-Language': 'fa',
			}
		})

		this.promise = null
		this.refreshingToken = false
	}


	async init(auth) {
		if (auth === true) {
			this.instance.interceptors.request.use(async request => {
				if (!_getAccessToken)
					return _resetAuthData(false)


				if (this.refreshingToken)
					await this.promise

				if (_checkUserExpiration() < 60 && !this.refreshingToken) {
					this.promise = new DeferredPromise()
					this.refreshingToken = true

					await callRefreshToken()

					this.promise.resolve()
					this.refreshingToken = false
				}

				request.headers['Authorization'] = 'bearer ' + _getAccessToken()
				return request
			}, error => {
				return Promise.reject(error)
			})
			return this.instance
		}
		return this.instance
	}

	CancelToken(){
		return axios.CancelToken
	}
}
